import { http } from '@/utils/http'

export const BPBASE = window.$envUtils('VUE_APP_BP_SERVICE')
/**
 * 新增web端配置的方法
 */
export const insertConfig = async (configs) => {
  return new Promise((resolve, reject) => {
    http.post(`${BPBASE}/channel/web/insertWebConfigs`, { data: configs }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 修改web端配置的方法
 */
export const updateConfig = async (configs) => {
  return new Promise((resolve, reject) => {
    http.put(`${BPBASE}/channel/web/updateWebConfigs`, { data: configs }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 通过主键id删除指定的配置数据
 * @param {string} id 主键id
 */
export const deleteConfigById = async ({ id }) => {
  const params = {
    id
  }
  return new Promise((resolve, reject) => {
    http.delete(`${BPBASE}/channel/web/deleteWebConfigById`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 根据主键id获取web端配置的方法
 * @param {string} id 主键id
 */
export const getConfigById = async ({ id }) => {
  const params = {
    id
  }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/channel/web/getWebConfigsById`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取web渠道配置列表的方法(分页)
 * @param {string} id 主键id
 */
export const getWebConfigsPaged = async (params) => {
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/channel/web/getWebConfigsPaged`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取web渠道相关的所有路由策略
 */
export const getWebStrategies = async () => {
  const params = {
    platformId: 'web'
  }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/channel/getStrategies`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
